module.exports = __webpack_public_path__ + "static/assets/86e15532bf675c4c67915038996b3bf7.gif";